import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { postRequest } from "lib/core/apiClient";
import { eventTypes } from "lib/utils/constants";
import { publishPostMessage } from "lib/utils/helpers";
import { parseUpSellData } from "lib/utils/upsell";
import { UpSellProductType } from "lib/types/upsell";
import { useMerchantUiConfig } from "lib/contexts/MerchantUIConfigProvider";

const issuerId = import.meta.env.VITE_ISSUER_ID;

export const useRecentViewData = () => {
  const [upsellData, setUpsellData] = useState<UpSellProductType[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchParams] = useSearchParams();

  const {
    state: {
      cartMetadata: { metadataLoading, ui_attributes },
    },
  } = useMerchantUiConfig();
  const { empty_cart_upsell_enabled } = ui_attributes ?? {};

  const handleRecentViewData = async (event: any) => {
    const cartOpen = searchParams.get("is_background_load") === "false";
    if (!cartOpen) {
      return;
    }
    try {
      if (event.data.type === eventTypes.RECENT_VISITED_VARIANTS) {
        publishPostMessage(eventTypes.CLOSE_RECENT_VISITED_VARIANTS, {});
        const variantList = event?.data?.payload?.data;
        const merchantId = event?.data?.payload?.merchantId;
        setIsLoading(true);

        const variantData = await postRequest(
          `/issuer/${issuerId}/merchant/${merchantId}/variant`,
          {
            variant_ids: variantList,
          },
          "CE_PUBLIC",
        );

        const productDataList = variantData?.map((data: any) => data.product);
        const { discountedUpsells, nonDiscountedUpsells } = parseUpSellData(productDataList);
        setUpsellData([...discountedUpsells, ...nonDiscountedUpsells]);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!metadataLoading) {
      if (empty_cart_upsell_enabled) {
        window.addEventListener("message", handleRecentViewData);
        return () => {
          window.removeEventListener("message", handleRecentViewData);
        };
      } else {
        setIsLoading(false);
      }
    }
  }, [searchParams, metadataLoading]);

  return {
    upsellData,
    isLoading,
  };
};
